import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ApiClient from "../../methods/api/apiClient";

export default function Footer() {
  const subDomain = "logistics.charlessmithassociates.com";
  // const subDomain = "localhost";
  const location = useLocation();
  const hostname = window.location.hostname;
  const isHomePage = location.pathname === "/";
  const isProductsPage = location.pathname === "/products";
  const [EqupmentListing, setEqupmentListing] = useState(
    localStorage.getItem("EqupmentListing")
      ? JSON.parse(localStorage.getItem("EqupmentListing"))
      : [],
  );
  useEffect(() => {
    fetchEquipment();
  }, []);

  const fetchEquipment = async () => {
    try {
      const params = { page: 1, count: 5, status: "active" };
      const query = new URLSearchParams(params).toString();
      const res = await ApiClient.get(`equipment-type/listing?${query}`);
      if (res?.success) {
        let data = res?.data?.data;
        if (data.length) {
          data = data.map((res) => ({
            name: res.title,
            id: res.id,
            image: res.image,
          }));
          data.sort((a, b) => a.name.localeCompare(b.name));
        }

        setEqupmentListing(data || []);
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      <footer>
        <div
          className={`${hostname === subDomain && isHomePage ? "bg-[#0A2540]" : " bg-white"}`}
        >
          <img
            src={
              hostname === subDomain && isHomePage
                ? "/assets/img/rectangle-black.png"
                : "/assets/img/footer-rectangle2.png"
            }
            className="w-full h-[80px] relative top-[1px]"
          />
          {/* <img src="/assets/img/rectangle-black.png" className="w-full h-[80px] relative top-[1px]"/> */}
          <div
            className={`${hostname === subDomain && isHomePage ? "bg-[#0A2540]" : "bg-white"}`}
          >
            <div className="container mx-auto px-5 pb-12">
              <div className="space-y-8">
                <div className="">
                  <img
                    src="/assets/img/logo.png"
                    alt="logo"
                    className="w-[120px] object-contain mx-auto"
                  />
                </div>
                <div className="max-sm:w-full text-center">
                  {/* <h3 className="text-[#414141] uppercase font-medium tracking-wide mb-2">Quick Links</h3> */}
                  <ul
                    className={`${hostname === subDomain && isHomePage ? "text-white" : "text-gray-400"} flex flex-wrap justify-center sm:gap-x-10 gap-5 space-y-1.5`}
                  >
                    <li className="max-sm:w-full !m-0">
                      <Link
                        to="/"
                        className={`${hostname === subDomain && isHomePage ? "text-white hover:text-[#98C65A]" : "text-[#414141] hover:text-[#116DAE]"} text-md`}
                      >
                        Home
                      </Link>
                    </li>
                    {hostname === subDomain ? (
                      ""
                    ) : (
                      <li className="max-sm:w-full !m-0">
                        <Link
                          to="/products"
                          className={`${hostname === subDomain && isHomePage ? "text-white hover:text-[#98C65A]" : "hover:text-[#116DAE] text-[#414141]"}   text-md`}
                        >
                          Shop
                        </Link>
                      </li>
                    )}
                    <li className="max-sm:w-full !m-0">
                      <Link
                        to="/about/us"
                        className={`${hostname === subDomain && isHomePage ? "text-white hover:text-[#98C65A]" : "text-[#414141] hover:text-[#116DAE]"} text-md`}
                      >
                        About Us
                      </Link>
                    </li>
                    <li className="max-sm:w-full !m-0">
                      <Link
                        to="/contact/us"
                        className={`${hostname === subDomain && isHomePage ? "text-white hover:text-[#98C65A]" : "text-[#414141] hover:text-[#116DAE]"}   text-md`}
                      >
                        Contact Us
                      </Link>
                    </li>
                    <li className="max-sm:w-full !m-0">
                      <Link
                        to="/privacy-policy"
                        className={`${hostname === subDomain && isHomePage ? "text-white hover:text-[#98C65A]" : "text-[#414141] hover:text-[#116DAE]"}   text-md`}
                      >
                        Privacy Policy
                      </Link>
                    </li>
                    <li className="max-sm:w-full !m-0">
                      <Link
                        to="/terms-and-conditions"
                        className={`${hostname === subDomain && isHomePage ? "text-white hover:text-[#98C65A]" : "text-[#414141] hover:text-[#116DAE]"}   text-md`}
                      >
                        Terms & Conditions
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              {/* {!isProductsPage && (
   <>
                <h3 className="text-[#414141] uppercase font-medium tracking-wide mb-3">Equipments</h3>
                <ul className="space-y-1.5 text-gray-400">
                  {EqupmentListing?.map((_itm)=>(<li>
                    <Link to={`/products?equipment=${_itm?.id}`} className="text-[#414141] hover:text-[#116DAE] text-[15px]">{_itm?.name}</Link></li>))}
              
                </ul>
                </>)} */}
            </div>

            {hostname === subDomain && isHomePage && (
              <div className="container mx-auto px-5 pt-5">
                <div
                  className="h-[3px]"
                  style={{
                    background:
                      " linear-gradient(90deg, #0A2540, #CCCCCC, #0A2540) border-box",
                  }}
                ></div>
              </div>
            )}

            <div
              className={`${hostname === subDomain && isHomePage ? "bg-[#0A2540]" : "bg-[#1169AA]"} text-sm font-[300] text-white text-center p-5`}
            >
              © 2026, <span className=""> Charles S. Smith & Associates </span>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
